import { actions, types } from './requests'
export const GETDOCUMENTLIST_TYPES = {
    ...types('GETDOCUMENTLIST'),
}
export const GETDOCUMENTLIST_ACTIONS = {
    ...actions('GETDOCUMENTLIST'),
}
